import { render, staticRenderFns } from "./CreateMobile.vue?vue&type=template&id=bba69994&"
import script from "./CreateMobile.vue?vue&type=script&lang=ts&"
export * from "./CreateMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports